import { render, staticRenderFns } from "./PracticeVedOld.vue?vue&type=template&id=3afd8066&"
import script from "./PracticeVedOld.vue?vue&type=script&lang=js&"
export * from "./PracticeVedOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports